var map = {
	"./404/bg-404.png": "ccd6",
	"./floating-button/btn-expand.png": "8c38",
	"./floating-button/icon-line-arrow-top.png": "ac61",
	"./floating-button/icon-line-game-detail.png": "01fb",
	"./floating-button/icon-line-screenshot.png": "7952",
	"./floating-button/icon-line-video.png": "986a",
	"./game-detail/date.svg": "b2ff1",
	"./game-detail/download-hover.svg": "f520",
	"./game-detail/download.svg": "836c",
	"./game-detail/video.svg": "e0ff",
	"./header/ic-cn.png": "ccd0",
	"./header/ic-en.png": "dac7",
	"./header/ic-ko.png": "c563",
	"./home/shortcut-game.png": "0bd8",
	"./home/shortcut-news.png": "21fb",
	"./home/shortcut-promotions.png": "4fff",
	"./jackpot/logo-0.png": "ec34",
	"./jackpot/logo-1.png": "995e",
	"./jackpot/logo-2.png": "9728",
	"./jackpot/mg-logo.png": "7a1f",
	"./jackpot/ticker-img-bg-0.png": "4b9e",
	"./jackpot/ticker-img-bg-1.png": "f343",
	"./jackpot/ticker-img-bg-2.png": "1fc9",
	"./jackpot/ticker-img-border.png": "d25c",
	"./mg-reward/achievement-step-1-en.png": "65b5",
	"./mg-reward/achievement-step-1.png": "588a",
	"./mg-reward/achievement-step-2-en.png": "5333",
	"./mg-reward/achievement-step-2.png": "c78b",
	"./mg-reward/achievement-step-3-en.png": "3298",
	"./mg-reward/achievement-step-3.png": "a7c8",
	"./mg-reward/bg-decobottom-egypt.png": "3281",
	"./mg-reward/bg-decobottom-home.png": "8f9e",
	"./mg-reward/bg-theme-egypt.png": "4780",
	"./mg-reward/cashback01.png": "e4391",
	"./mg-reward/cashback02.png": "56be",
	"./mg-reward/epicwin.png": "3afd",
	"./mg-reward/epicwin_en.png": "2083",
	"./mg-reward/free.png": "ea33",
	"./mg-reward/freespin.png": "1833",
	"./mg-reward/growth.png": "043f",
	"./mg-reward/ingame.png": "d6bc",
	"./mg-reward/ingame_en.png": "4810",
	"./mg-reward/integration.png": "7277",
	"./mg-reward/logo-mgreward-cn.svg": "5804",
	"./mg-reward/logo-mgreward-en.svg": "52e8",
	"./mg-reward/mg-reward-logo-en.png": "129e",
	"./mg-reward/mg-reward-logo.png": "7fd5",
	"./mg-reward/mgw-achievement.png": "5b25",
	"./mg-reward/mgw-benefit.png": "cc17",
	"./mg-reward/mgw-bg-mgw-benefit.png": "2058",
	"./mg-reward/mgw-bg-mgw-bottomcoins.png": "7ed9",
	"./mg-reward/mgw-bg-mgw-magic.png": "bd7e",
	"./mg-reward/mgw-bg-mgw-playerzone.png": "fca2",
	"./mg-reward/mgw-bottomcoins.png": "987e",
	"./mg-reward/mgw-mgw.png": "4b7e",
	"./mg-reward/mgw-playerzone.png": "a1fd",
	"./mg-reward/mgw-prestige-en.png": "08ee",
	"./mg-reward/mgw-prestige.png": "7f20",
	"./mg-reward/mgw-store.png": "9346",
	"./mg-reward/mgw-tournament-mobile.png": "cfbd",
	"./mg-reward/mgw-tournament.png": "ce64",
	"./mg-reward/mgw_end.png": "38a7",
	"./mg-reward/mgw_epicwin.png": "cfb5",
	"./mg-reward/mgw_jackpot.png": "5ebe",
	"./mg-reward/mgw_playerlobby.png": "95dd",
	"./mg-reward/mgw_playerzone.png": "f24b",
	"./mg-reward/playerlobby.png": "5eb5",
	"./mg-reward/playerlobby_en.png": "1ba5",
	"./mg-reward/playerzone.png": "e608",
	"./mg-reward/playerzone_en.png": "fda2",
	"./mg-reward/prestige-01.png": "b0aa",
	"./mg-reward/prestige-02.png": "cfdf",
	"./mg-reward/prestige-03.png": "772d5",
	"./mg-reward/prestige-04.png": "785aa",
	"./mg-reward/store.png": "282e",
	"./mg-reward/store_en.png": "910c",
	"./modal/coming-soon.png": "10e9",
	"./modal/ic-error.png": "d68f",
	"./modal/ic-success.png": "0560",
	"./shared/ic-18.png": "a5f9",
	"./shared/loading.svg": "24de",
	"./shared/logo-en.png": "20d1",
	"./shared/logo-mg.png": "2704",
	"./shared/logo-zh.png": "c6c2",
	"./shared/logo.png": "e50f",
	"./shared/mg.png": "d018",
	"./shared/mobile-frame.png": "3a02",
	"./shared/upg.png": "0cbd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";